import React from 'react'
import Popup from '../../../../../components/popup/Popup'
import styles from "./GetW8W9FormsModal.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import Button from '../../../../../components/button/Button'
import Loadable from '../../../../../components/loadable/Loadable'

const GetW8W9FormsModal = ({
    title = "",
    bodyText,
    isOpen,
    confirmationButtonProps = {
        onConfirmationCb: () => { },
        confirmationButtonText: "Submit",
        confirmationButtonStyles: {},
        confirmationButtonType: BUTTON_TYPE.PRIMARY,
    },
    cancelButtonProps = {
        onCancelCb: () => { },
        onCloseCb: () => { },
        cancelButtonText: "Cancel",
        cancelButtonStyles: {},
        cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
    },
    customStyle = {},
    isClose = true,
    onSelectCb = () => { },
    options,
    name = "",
    value = { label: "", value: "" },
    placeHolder = "",
    loadingState = false,
    loaderLoadingStates = [],
    loaderMessageMap = {},
    preserveLoaderChildMount = false,
}) => {
    return (
        <Popup title={title} onCloseCb={isClose ? cancelButtonProps.onCancelCb : cancelButtonProps.onCloseCb} isPopupOpen={isOpen} childrenStyles={{ ...styles.popupModal, ...customStyle }}>
            <Loadable
                currentState={loadingState?.state}
                loadingStates={loaderLoadingStates}
                isNewLoadable={true}
                messageMap={loaderMessageMap}
                preserveChildMount={preserveLoaderChildMount}
            >
                <div style={styles.bodyContainer}>

                    {bodyText && <span>{bodyText}</span>}

                    <div style={styles.selectForms}>
                        <SelectDropdown
                            name={name}
                            placeHolder={placeHolder}
                            value={value}
                            onSelectCb={onSelectCb}
                            options={options}
                        />
                    </div>
                </div>


                <HorizontalSeparator />

                <div style={styles.footer}>

                    {confirmationButtonProps.confirmationButtonText && <div onClick={confirmationButtonProps.onConfirmationCb}>
                        <Button
                            type={confirmationButtonProps.confirmationButtonType}
                            style={{ ...confirmationButtonProps.confirmationButtonStyles, ...styles.buttons }}
                        >
                            {confirmationButtonProps.confirmationButtonText}
                        </Button>
                    </div>}


                    <div onClick={cancelButtonProps.onCancelCb}>
                        <Button
                            type={cancelButtonProps.cancelButtonType}
                            style={{ ...cancelButtonProps.cancelButtonStyles, ...styles.buttons }}
                        >
                            {cancelButtonProps.cancelButtonText}
                        </Button>
                    </div>

                </div>
            </Loadable>
        </Popup>
    )
}

export default GetW8W9FormsModal
